/* global Insticator */
import { h, Component } from 'preact';
import dlv from 'dlv';

import { injectScripts } from '@cube/script-injector';

export class InsticatorJs extends Component {
	componentDidMount() {}

	render() {
		return (
			<iframe
				src="/embed-insticator"
				width="100%"
				height="650px"
				frameBorder="0"
				sandbox="allow-forms allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts allow-top-navigation-by-user-activation"
			/>
		);
	}
}

/** Creates div for insticator js insertion
 */
export class InsticatorJsInjector extends Component {
	fireLoad = () => {
		let pageCompleteCheck =
			!this.props.requireComplete || document.readyState === 'complete';
		if (window.Insticator && !this.state.hasLoaded && pageCompleteCheck) {
			this.setState({ hasLoaded: true });
			if (dlv(this.props, 'showAd1'))
				window.Insticator.ad.loadAd('div-insticator-ad-1');
			if (dlv(this.props, 'showAd2'))
				window.Insticator.ad.loadAd('div-insticator-ad-2');
			if (dlv(this.props, 'showAd3'))
				window.Insticator.ad.loadAd('div-insticator-ad-3');
			if (dlv(this.props, 'showAd4'))
				window.Insticator.ad.loadAd('div-insticator-ad-4');
			window.Insticator.load('em', { id: this.props.id });
		}
	};

	loadJs = () => {
		if (!window.Insticator) {
			window.Insticator = {
				ad: {
					loadAd(b) {
						Insticator.ad.q.push(b);
					},
					q: []
				},
				helper: {},
				embed: {},
				version: '4.0',
				q: [],
				load(t, o) {
					Insticator.q.push({ t, o });
				}
			};

			let scripts = [
				{
					src:
						this.props.src ||
						`https://d3lcz8vpax4lo2.cloudfront.net/ads-code/28a680b0-fb19-489b-b9cf-0d9c4e5c52d7.js`
				}
			];

			if (this.props.loaderSrc) {
				scripts.push({
					src: this.props.loaderSrc
				});
			}

			injectScripts(scripts).then(
				() => {
					this.fireLoad();
				},
				(err) => {
					console.error('Insticator script failed to load:', err);
				}
			);
		}
	};

	componentWillMount() {
		// If not delaying load, load js immediately
		if (!this.props.requireComplete) this.loadJs();
	}

	componentDidMount() {
		if (this.props.requireComplete && document.readyState !== 'complete') {
			// if require complete and not yet complete, add listener for load complete
			window.addEventListener(
				'load',
				this.props.requireComplete ? this.loadJs : this.fireLoad
			);
		}
		else {
			this.props.requireComplete ? this.loadJs() : this.fireLoad();
		}
	}

	shouldComponentUpdate = () => false;

	render({ id, showAd1, showAd2, showAd3, showAd4, embedClass }) {
		return (
			<div id="insticator-container" class={`embedid-${id}`}>
				{'above' === showAd1 && <div id="div-insticator-ad-1" />}
				{'above' === showAd2 && <div id="div-insticator-ad-2" />}
				{'above' === showAd3 && <div id="div-insticator-ad-3" />}
				{'above' === showAd4 && <div id="div-insticator-ad-4" />}
				<div id="insticator-embed" class={embedClass} />
				{'below' === showAd1 && <div id="div-insticator-ad-1" />}
				{'below' === showAd2 && <div id="div-insticator-ad-2" />}
				{'below' === showAd3 && <div id="div-insticator-ad-3" />}
				{'below' === showAd4 && <div id="div-insticator-ad-4" />}
			</div>
		);
	}
}
